module.exports = __webpack_public_path__ + "img/20200515_161803.17d170ba.jpg";